<app-login-form (login)="onLogin($event)" [message]="message"></app-login-form>